// Shared utils for working with Objects/dicts

// Return a new object with the keys and values reversed
export const invert = (obj) => {
    return Object.keys(obj).reduce((ret, key) => {
        ret[obj[key]] = key;
        return ret;
    }, {});
}
